import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

import { Font } from '@react-pdf/renderer';

import {style} from '../../components/pdf/fontstyles';
import {AutoText} from '../../components/pdf/autoText'; 




const styles = StyleSheet.create({
  page: {
    padding: 10, // Reduce padding

    fontSize: 10,
    marginLeft: 40,
    marginRight: 40,
    marginTop: 10,
    marginBottom: 10,
    lineHeight: 1.5,

  },
  table: {
    marginTop: 10,
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
  },
  row: {
    flexDirection: 'row',
    borderBottom: '1px solid #000',
  },
  cell: {
  paddingVertical: 3,   // ↓ was 5
  paddingHorizontal: 4,
  borderRight: '1px solid #000',
  lineHeight: 0.8,      // ↓ tighten text height
},

  headerCell: {
    fontWeight: 'bold',
    backgroundColor: '#f2f2f2',
  },
  // Column specific styles (adjust widths for each column)
  srNoCell: {
    width: '10%', // First column with smaller width
  },
  detailsCell: {
    width: '70%', // Second column with larger width
  },
  pageNoCell: {
    width: '20%', // Third column with medium width
  },
});

const tableData = [
  ['1', 'Annexure A – Departmental Data Sheet', ''],
  ['2', 'School Letter', ''],
  ['3', 'Employee Letter', ''],
  ['4', 'Form A / B – Commutation of Pension', ''],
  ['5', 'Form No. 15 – Annexure I & Annexure II', ''],
  ['6', 'Specimen Signature and Passport Size Photograph', ''],
  ['7', 'Thumb & Finger Impression and Identification Marks', ''],
  ['8', 'Form No. 3 – Details of Family', ''],
  ['9', 'Form No. 1 – Nomination for Death-cum-Retirement Gratuity', ''],
  ['10', 'Last Pay Certificate', ''],
  ['11', 'Source of Pay Drawn', ''],
  ['12', 'Periods of Vacations', ''],
  ['13', 'History of Break in Service', ''],
  ['14', 'Service History Sheet', ''],
  ['15', 'Statement of Leave Availed by the Employee', ''],
  ['16', 'Rough Calculation of Pension and Gratuity', ''],
  ['17', 'Declaration for Pension / Service Gratuity / D.C.R. Gratuity / Family Pension', ''],
  ['18', 'Declaration for Pension and Gratuity', ''],
  ['19', 'No Departmental Enquiry & No Government / Management Dues Certificate', ''],
  ['20', 'Certificate – School is 100% Aided by School Education & Sports Department', ''],
  ['21', 'Consent Form', ''],
  ['22', 'Non-Employment Certificate', ''],
  ['23', 'वचनपत्र : २२.१२.२०२१ चे सहपत्र', ''],
  ['24', 'Miscellaneous Certificates', ''],
  ['25', 'Pay Fixation Orders (as applicable) with Option Form', ''],
  ['26', 'Related Letters (Xerox Copies)', ''],
  ['27', 'Service Book with copy of School Leaving / S.S.C. Certificate for Verification of Age', 'Attached'],
  ['28', 'Leave Account duly verified and certified in the Service Book', 'Verified'],
];


const PensionEnclosure = () => (
  <View style={styles.page}>
    <Text style={[style.ArialBold, { textAlign: 'center', fontSize: 16, marginTop: 20, marginBottom: 10 }]}>
      LIST OF ENCLOSURES
    </Text>
    <View style={styles.table}>
      <View style={[styles.row, styles.headerCell]}>
        <Text style={[styles.cell, styles.srNoCell]}>SR. No</Text>
        <Text style={[styles.cell, styles.detailsCell]}>Details</Text>
        <Text style={[styles.cell, styles.pageNoCell]}>Page No</Text>
      </View>
      
      {tableData.map(([srNo, details, pageno], index) => (
        <View style={styles.row} key={index}>
          <Text style={[styles.cell, styles.srNoCell]}>{srNo}</Text>
          <AutoText style={[styles.cell, styles.detailsCell]}>{details}</AutoText>
          <Text style={[styles.cell, styles.pageNoCell]}>{pageno}</Text>
        </View>
      ))}
    </View>
  </View>
);

export default PensionEnclosure;
